module.exports = __webpack_public_path__ + "static/img/middle-btn.0d27b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/middle-btn.png
// module id = IMAM
// module chunks = 213